import React from "react";
import { Modal, Spinner } from "reactstrap";

const RoleModal = ({ loading, show, mode, formData, setFormData, onSubmit, onClose }) => {
  if (!show) return null;

  const isView = mode === "view";
  const isEdit = mode === "edit";
  const isCreate = mode === "create";

  return (
    <Modal isOpen={show} toggle={onClose} backdrop="static" keyboard={false}>
      <form
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            e.currentTarget.requestSubmit();
          }
        }}
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}>
        <div className="modal-header">
          <h5 className="modal-title">
            {isCreate && "Create Role"}
            {isView && "View Role"}
            {isEdit && "Edit Role"}
          </h5>
          <button className="btn-close" onClick={onClose}></button>
        </div>

        <div className="modal-body">
          {loading ? (
            <div className="text-center my-4">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <div className="mb-3">
                <label className="form-label">Role Name*</label>
                <input
                  type="text"
                  disabled={isView}
                  className="form-control"
                  value={formData.Name || ""}
                  onChange={(e) => setFormData({ ...formData, Name: e.target.value })}
                  required
                />
              </div>
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={!!formData.IsActive}
                  onChange={(e) =>
                    setFormData({ ...formData, IsActive: e.target.checked })
                  }
                />
                <label className="form-check-label">
                  Is Active?
                </label>
              </div>
            </>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>

          {!isView && (
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {isCreate ? "Create" : "Save Changes"}
            </button>
          )}
        </div>
      </form>
    </Modal>
  );
};

export default RoleModal;
